{
	"showButtonTitle": "Afișează",
	"hideButtonTitle": "Ascunde"
}
